import {useDispatch, useSelector} from "react-redux";
import auth from "../../../utils/authentication";
import {setViewEpisode} from "../../../utils/TorresowoBackend";
import cap17drive from "../index";
import {useMemo} from "react";

const UseViewTMDBContent = () => {

    const thing = useSelector(cap17drive.selectors.getSelectedEpisode);
    const dispatch = useDispatch();

    function markThingAsView(view, onSucess,) {
        setViewEpisode({
            uid: auth.currentUser.uid,
            serieId: thing.show_id ?? thing.id,
            season_number: thing.season_number,
            episode_number: thing.episode_number,
            view
        }).then(() => {
            dispatch(cap17drive.actions.updateViewEpisode(view, thing));
            if (onSucess) {
                onSucess();
            }
        });
    }

    function markEpisodeAsView(episode, view, onSucess,) {
        setViewEpisode({
            uid: auth.currentUser.uid,
            serieId: episode.show_id ?? episode.id,
            season_number: episode.season_number,
            episode_number: episode.episode_number,
            view
        }).then(() => {
            if (onSucess) {
                onSucess();
            }
        });
    }

    const itemIsViewed = useMemo(() => {
        return thing?.view ?? false;
    }, [thing]);

    return {thing, itemIsViewed, markThingAsView, markEpisodeAsView};
}

export default UseViewTMDBContent;
